// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ProjectPage.test.tsx
import { Flex, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import { type AskV2CommentContext } from "./types";

import { AskPunttReviewCommentBadge } from "../../components/ask-puntt-review";
import {
  normalizeReviewCommentTag,
  reviewCommentTagLabelKey,
} from "../review/reviewCommentTags";

type CommentContextChipProps = {
  context: AskV2CommentContext;
  testId: string;
  onRemove?: () => void;
};

export function CommentContextChip({
  context,
  testId,
  onRemove,
}: CommentContextChipProps) {
  const { t } = useTranslation("ui");
  const normalizedTag =
    context.tag != null ? normalizeReviewCommentTag(context.tag) : null;
  const tagLabel =
    normalizedTag != null ? t(reviewCommentTagLabelKey(normalizedTag)) : null;

  return (
    <Flex
      align="center"
      gap="2"
      className="max-w-full rounded-md bg-puntt-neutral-gray-3 px-2 py-1"
      data-testid={testId}
    >
      <AskPunttReviewCommentBadge number={context.number} />
      <div className="min-w-0">
        <Text
          size="1"
          className="block max-w-[180px] truncate font-medium text-puntt-neutral-gray-12"
        >
          {context.title}
        </Text>
        {tagLabel ? (
          <Text size="1" className="text-puntt-neutral-gray-9">
            {tagLabel}
          </Text>
        ) : null}
      </div>
      {onRemove ? (
        <button
          type="button"
          data-testid={`ask-v2-remove-comment-context-${context.id}`}
          onClick={onRemove}
          className="text-puntt-neutral-gray-9 hover:text-puntt-neutral-gray-12"
          aria-label={t("askV2.transport.removeCommentContext")}
        >
          ×
        </button>
      ) : null}
    </Flex>
  );
}
